import { VisionApiError } from '@/lib/vision/client'

/**
 * Ops-friendly queue / detail error copy. Distinguishes HTTP status (401 vs 5xx)
 * from a real network miss so "Vision rejected the session" is not shown as
 * "Couldn't reach the server".
 */
export function friendlyQueueError(error: unknown): string {
  if (error instanceof VisionApiError) {
    if (error.status === 401) {
      return 'Vision rejected the session (401). Check that local Vision accepts the Pulse token.'
    }
    if (error.status === 403) {
      return "You don't have access to this queue (403)."
    }
    if (error.status === 502 || error.status === 503 || error.status === 504) {
      return "Couldn't reach the server. Try again in a moment."
    }
    if (error.status >= 500) {
      return `Vision returned ${error.status}. Try again in a moment.`
    }
    return error.message || `Request failed (${error.status}).`
  }
  if (error instanceof TypeError) {
    return "Couldn't reach the server. Try again in a moment."
  }
  if (!(error instanceof Error) || !error.message) {
    return "Couldn't reach the server. Try again in a moment."
  }
  const raw = error.message
  if (/failed to fetch|networkerror|load failed|econnrefused/i.test(raw)) {
    return "Couldn't reach the server. Try again in a moment."
  }
  return raw
}
